export const moduleConfig = {
    entityKey: 'prices',
    titles: {
        singular: 'Price',
        plural: 'Prices'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};